<main class="contact-page container">
  <section class="contact-hero">
    <h1 class="contact-hero__title">{{ 'global.contact_us' | translate }}</h1>
  </section>

  <section class="contact-content">
    <aside
      class="contact-cards"
      [attr.aria-label]="'global.contacts' | translate">
      @for (info of contactInfo; track $index) {
        <article class="info-card">
          <span class="info-card__icon">
            <i class="iconsax" [attr.icon-name]="info.icon"></i>
          </span>
          <h2 class="info-card__title">{{ info.title | translate }}</h2>
          @if (info.href) {
            <a
              class="info-card__line info-card__line--link"
              [href]="info.href"
              [ngClass]="{
                'info-card__line--ltr': info.isNumberMode,
              }">
              {{ (info.description | translateData) || '' | translate }}
            </a>
          } @else {
            <p
              class="info-card__line"
              [ngClass]="{
                'info-card__line--ltr': info.isNumberMode,
              }">
              {{ (info.description | translateData) || '' | translate }}
            </p>
          }
        </article>
      }
    </aside>

    <section class="contact-form-wrapper">
      <h2 class="contact-form-wrapper__title">
        {{ 'contactPage.formTitle' | translate }}
      </h2>

      <form [formGroup]="contactForm" (submit)="submitContactForm()">
        <div class="contact-form-grid">
          <pwj-input
            icon="user-1"
            iconPosition="left"
            formControlName="name"
            label="global.full_Name"
            placeholder="global.enter_your_full_Name"
            [messages]="{ required: 'requires.fullName' }"></pwj-input>

          <pwj-phone-number
            formControlName="mobile"
            label="global.phone_number"
            placeholder="global.enter_your_phone"
            [messages]="{
              required: 'requires.phoneNumber',
              invalidPhoneNumber: 'requires.invalidMobile',
            }"></pwj-phone-number>
        </div>

        <pwj-input
          icon="mail"
          iconPosition="left"
          formControlName="email"
          label="global.email"
          placeholder="global.enter_your_email"
          [messages]="{
            required: 'requires.emailAddress',
            email: 'requires.invalidEmail',
          }"></pwj-input>

        <pwj-input
          icon="stickynote"
          iconPosition="left"
          formControlName="description"
          [isTextAreaMode]="true"
          rows="4"
          label="global.description"
          placeholder="global.description"
          [messages]="{ required: 'requires.description' }"></pwj-input>

        <pwj-button
          variant="primary"
          size="large"
          icon="chevron-right"
          [iconReversePosition]="true"
          [disabled]="contactForm.invalid || isDisabledSubmitBtn"
          type="submit"
          [wFull]="true">
          {{ 'global.confirmation' | translate }}
        </pwj-button>
      </form>
    </section>
  </section>

  <section class="contact-map">
    <div class="contact-map__header">
      <div>
        <h2 class="contact-map__title">{{ 'global.location' | translate }}</h2>
      </div>
    </div>
    <div class="contact-map__frame">
      <pwj-map-box [location]="companyLocation"></pwj-map-box>
    </div>
  </section>
</main>
